/* eslint-disable no-console,class-methods-use-this */
import { Socket } from 'phoenix';
import EventEmitter from 'events';
import omit from 'lodash/omit';
import SystemChannel from './channels/system_channel';
import CircleOfCareChannel from './channels/circle_of_care_channel';
import FileUploader from './attachments/file_uploader';
import { DISABLE_LOGS } from '../../constants/env';

export default class Connection extends EventEmitter {
  constructor({
    authToken,
    userId,
    socketUrl,
    attachmentsUploadUrl,
    teamId,
    teamUserId,
    isProvider,
  }) {
    super();

    this.uploader = new FileUploader(attachmentsUploadUrl);

    this.authToken = authToken;
    this.userId = userId;
    this.teamId = teamId;
    this.teamUserId = teamUserId;
    this.isProvider = isProvider;

    this.circles = {};
    this.connected = false;

    this.socket = new Socket(socketUrl, {
      logger: this._logger,
      params: {
        token: this.authToken,
        platform: 'P_WEB',
      },
    });
  }

  connect() {
    this.socket.connect();
    this._handleConnection();
  }

  disconnect() {
    this.socket.disconnect();

    this.authToken = null;
    this.userId = null;
    this.circles = {};
    this.connected = false;
    this.teamId = null;
    this.teamUserId = null;
    this.isProvider = false;

    console.log('--- Chat connection closed.');
  }

  _handleConnection() {
    this.systemChannel = new SystemChannel(this);
    this.connected = true;

    this.emit('connection_opened', this);
  }

  getUploader() {
    return this.uploader;
  }

  getCircle(channelId) {
    if (!this.connected) {
      console.error('Connect before!');
      return null;
    }

    return this.circles[channelId];
  }

  createChannel(channelId, options) {
    const { unreadCount = 0, lastMessageAt } = options || {};

    if (!this.connected) {
      console.error('Connect before!');
      return null;
    }

    if (!this.circles[channelId]) {
      const actions = {
        emit: (...args) => this.emit(...args),
        push: (...args) => this.systemChannel.channel.push(...args),
      };

      const circle = new CircleOfCareChannel(channelId, actions, {
        userId: this.userId,
        unreadCount,
        lastMessageAt,
        isProvider: this.isProvider,
      });

      this.circles[channelId] = circle;
    }

    return this.circles[channelId];
  }

  removeChannel(channelId) {
    this.circles = omit(this.circles, [channelId]);
  }

  _logger(kind, msg, data) {
    if (!DISABLE_LOGS) {
      console.log(kind, ': ', msg, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/chatAPI/connection.js